/**
    * @description      :
    * @author           : verdentum
    * @group            :
    * @created          : 04/08/2021 - 14:20:08
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/08/2021
    * - Author          : verdentum
    * - Modification    :
**/
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { apiUrl } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  response:any;
  apiLink = apiUrl+'/api/';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toastr: ToastrService
  ) { }
//===============add menu ===================//
  async addMenu(surveyDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/add', surveyDetails, {headers: headers}).toPromise().then(response => {
      console.log(response)
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }



    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return true;
    });
  }


  //===========get all menu=================
  async getAllMenu(org, role) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/get_all_menu', {org_code:org, role:role}, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.globalmenus;
    });
  }
  //===========get parent menu=================
  async getAllParentMenu() {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/get_parent_menu', {}, {headers: headers}).toPromise().then(response => {

      this.response = response;
      if(this.response.status == 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      return this.response.globalmenus;
    });
  }


   //===========delete menu=================
  async deleteMenu(menuDetails: any) {
     console.log(menuDetails)
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/delete', menuDetails, {headers: headers}).toPromise().then(response => {
console.log(response)
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    });
  }


//===============menu update===================//
  async updateMenu(editDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/update', {menu_id:editDetails.menu_id, editDetails}, {headers: headers}).toPromise().then(response => {
      console.log(response)
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }



    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return true;
    });
  }



  //===============get org menu===================//
  async getAllOrgMenu(org:any, role:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/get_org_menu', {org_code:org, role:role}, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      }
      
      return this.response.menus;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }


  //===============update org menu===================//
  async updateOrgMenu(menuDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/update_org_menu', menuDetails, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return true;
    });
  }

  //===============update org menu name===================//
  async updateOrgMenuName(menuDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/update_org_menu_name', menuDetails, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }
  //===============update org menu position===================//
  async updateOrgMenuPosition(menuDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/update_org_menu_pos', menuDetails, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

  //=============== A2.1 — server-driven menu engine resolver (GET /api/menu) ===============//
  // Returns { status, org_code, role, menu:{main,avatar,mobile} } or (with ?surface) { ..., surface, menu:[tree] }.
  async getMenuTree(surface?: string) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    const url = this.apiLink + 'menu' + (surface ? ('?surface=' + surface) : '');
    return this.http.get(url, { headers }).toPromise().then((response:any) => {
      return response;
    }).catch(err => {
      console.log(err);
      return null;
    });
  }

  //=============== Engine admin (org-admin menu customization, /user/module) ===============//
  // Reuses the /api/menu-admin/* endpoints (isAuth). Org admin edits their org+role set:
  // ensure an editable org set, load it, rename (label_override) + reorder (sort_order).
  private async enginePost(path: string, body: any) {
    let userDetails = await this.authService.getUserDetails(),
        token = userDetails.token ? userDetails.token : '';
    let headers = new HttpHeaders({ 'Authorization': `Bearer: ${token}` });
    headers.append('Authorization', token);
    return this.http.post(this.apiLink + 'menu-admin/' + path, body, { headers }).toPromise()
      .then((r: any) => r).catch(err => { console.log(err); return null; });
  }

  menuForScope(org_code: any, role: any, surface = 'main') { return this.enginePost('sets/for-scope', { org_code, role, surface }); }
  menuEnsureOrg(org_code: any, role: any, surface = 'main') { return this.enginePost('sets/ensure-org', { org_code, role, surface }); }
  menuSetGet(set_id: any)            { return this.enginePost('sets/get', { set_id }); }
  menuSetItemUpdate(item: any)       { return this.enginePost('set-items/update', item); }
  menuSetItemReorder(items: any[])   { return this.enginePost('set-items/reorder', { items }); }
  menuSetLanding(set_id: any, landing_route: any) { return this.enginePost('sets/set-landing', { set_id, landing_route }); }

  //===============update default menu===================//
  async updateDefaultMenu(menuDetails:any) {
    let userDetails = await this.authService.getUserDetails(),
    token = userDetails.token ? userDetails.token : '';

    // Create header and append JWT token
    let headers = new HttpHeaders({
      'Authorization': `Bearer: ${token}`
    });
    headers.append('Authorization', token);

    return this.http.post(this.apiLink+'globalmenu/update_default_menu', menuDetails, {headers: headers}).toPromise().then(response => {
      this.response = response;
      if(this.response.status === 0) {
        this.toastr.error(this.response.msg, 'Error!', {
          timeOut: 5000,
        });
        return false;
      } else {
        this.toastr.success(this.response.msg, 'Success!', {
          timeOut: 5000,
        });
        return true;
      }
    }).catch(err => {
      console.log(err);
      this.toastr.error('Could not connect to server. Please check your network connection.', 'Network Error!', {
        timeOut: 5000,
      });
      return false;
    });
  }

}
